import { useMemo } from 'react';
import { useCurrentAgent } from '@/features/chats/stores';
import { chatOptionsFor } from './ChatOptions.registry';
import { ChatOptionsProps } from './ChatOptions.types';

/**
 * Renders the chat options which depends on the current agent in context. For example, for image-generation agent,
 * we show aspect-ratio and model options, for video agents we show resolution and duration options, etc.
 *
 * This is an extensible component that can be expanded in the future to include more options as needed for specific agents.
 *
 * The idea is to eventually make this component dynamic such that the rendered options are derived from the agent's schema or configuration.
 * For now though, the options are statically coded based on the agent id
 */

export const ChatOptions = (props: ChatOptionsProps) => {
  const agent = useCurrentAgent();

  const choice = useMemo(() => (agent ? chatOptionsFor(agent) : undefined), [agent]);

  if (choice) {
    return (
      <div className="flex gap-2">
        <choice.Component {...props} {...choice.props} />
      </div>
    );
  }
  return null;
};
